import React from 'react';

const HoratioEmbed: React.FC<{ src: string }> = ({ src }) => {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <iframe
        src={src}
        title="Welcome to AIStudio"
        style={{ width: '100%', height: '100%', border: 'none' }}
        allow='microphone'
      />
    </div>
  );
};

export default HoratioEmbed;
